import { render, staticRenderFns } from "./ArticleDetail.vue?vue&type=template&id=430ddb7b&"
import script from "./ArticleDetail.vue?vue&type=script&lang=js&"
export * from "./ArticleDetail.vue?vue&type=script&lang=js&"
import style0 from "./ArticleDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports